import { adminHttpClient } from '../../../commons/adminHttpClient'

const setIchraConfirmRenewalBenefitClasses = (planPeriodId: string): Promise<void> => {
  return adminHttpClient.put(`/Benefit/BenefitRenewal/Ichra/ConfirmRenewalBenefitClasses`, { planPeriodId })
}

export default setIchraConfirmRenewalBenefitClasses
